import { render, staticRenderFns } from "./OrderModuleDialog.vue?vue&type=template&id=7004643a&scoped=true&"
import script from "./OrderModuleDialog.vue?vue&type=script&lang=js&"
export * from "./OrderModuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderModuleDialog.vue?vue&type=style&index=0&id=7004643a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004643a",
  null
  
)

export default component.exports